export default __webpack_public_path__ + "static/media/OmaduroChurchill.fbe32efa.png";